import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getEventTypes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-type`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event types:', error.response?.data || error);
    throw error;
  }
};

export const getEventTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-type/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event type:', error.response?.data || error);
    throw error;
  }
};

export const createEventType = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-type`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating event type:', error.response?.data || error);
    throw error;
  }
};

export const updateEventType = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/event-type/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating event type:', error.response?.data || error);
    throw error;
  }
};

export const deleteEventType = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/event-type/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting event type:', error.response?.data || error);
    throw error;
  }
};
